const URL_PATTERN = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi;
const TRAILING_PUNCTUATION = /[.,!?;:\])}]+$/;

function linkParts(raw) {
  const trailing = raw.match(TRAILING_PUNCTUATION)?.[0] ?? '';
  const value = trailing ? raw.slice(0, -trailing.length) : raw;
  const href = value.toLowerCase().startsWith('www.') ? `https://${value}` : value;

  try {
    const url = new URL(href);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
  } catch {
    return null;
  }

  return { value, href, trailing };
}

/** Render plain user text with safe, clickable web links. */
function linkifyUrls(text) {
  const value = String(text ?? '');
  const nodes = [];
  let cursor = 0;

  for (const match of value.matchAll(URL_PATTERN)) {
    const start = match.index ?? 0;
    const parts = linkParts(match[0]);

    if (start > cursor) nodes.push(value.slice(cursor, start));
    if (!parts?.value) {
      nodes.push(match[0]);
    } else {
      nodes.push(
        <a
          key={`${start}-${parts.href}`}
          href={parts.href}
          target="_blank"
          rel="noopener noreferrer nofollow ugc"
        >
          {parts.value}
        </a>
      );
      if (parts.trailing) nodes.push(parts.trailing);
    }
    cursor = start + match[0].length;
  }

  if (cursor < value.length) nodes.push(value.slice(cursor));
  return nodes;
}

/**
 * Mentions and tags, marked up after the URL pass so a handle inside a link
 * is left alone. The sentence is the only input, so it has to render as one.
 */
const MENTION_OR_TAG = /(^|[^\w@#])([@#])([\p{L}\p{N}][\p{L}\p{N}_-]{0,29})/giu;

function markUp(chunk, keyBase) {
  const out = [];
  let last = 0;
  let n = 0;
  for (const match of chunk.matchAll(MENTION_OR_TAG)) {
    const [whole, lead, sigil, word] = match;
    const start = match.index + lead.length;
    if (start > last) out.push(chunk.slice(last, start));
    out.push(
      sigil === '@'
        ? <a key={`${keyBase}-m${n}`} className="mention" href={`/@${word.toLowerCase()}`}>@{word}</a>
        : <span key={`${keyBase}-t${n}`} className="hashtag">#{word}</span>
    );
    n += 1;
    last = match.index + whole.length;
  }
  if (last < chunk.length) out.push(chunk.slice(last));
  return out;
}

export default function LinkedText({ text }) {
  return linkifyUrls(String(text ?? '')).flatMap((part, i) => (
    typeof part === 'string' ? markUp(part, i) : part
  ));
}
